import React from "react";
import { withRouter } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import moment from "moment";
import axios from "axios";
import { API_ROOT } from "../utils/api-config";
import { sortableContainer, sortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import { Map, Polyline, Marker, GoogleApiWrapper } from "google-maps-react";
import Spinner from "../layout/Spinner";
import SweetAlert from "react-bootstrap-sweetalert";
import PubNub from "pubnub";
import { PubNubProvider, PubNubConsumer } from "pubnub-react";
import MessageIcon from "@material-ui/icons/Message";
import AddPickups from "./AddPickups";

const pubnub = new PubNub({
  publishKey: "#",
  subscribeKey: "#",
  uuid: "Route",
});

const SortableItem = sortableElement(({ value }) => <li>{value}</li>);

const SortableContainer = sortableContainer(({ children }) => {
  return <ul>{children}</ul>;
});
const mapStyles = {
  width: "100%",
  height: "600px",
};

let geocoder;
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
    "Content-Type": "application/json",
  },
};
let driver = null;
let channels = null;
let driverPosition = null;
let newOrder = [];

class RouteTasksSortable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      directions: undefined,
      places: [],
      completedPlaces: [],
      stores: [],
      showComplete: false,
      showPickups: false,
      bounds: undefined,
      triangleCoords: undefined,
      triangleCoordsAll: undefined,
      triangleCoordsBasic: undefined,
      newOrder: [],
      deliveries: [],
      merchants: [],
    };
    this.refsArray = [];
  }
  componentDidMount() {
    this.filterRoutes();
    this.initializeDeliveries();
  }

  initializeDeliveries = () => {
    const deliveries = {};
    this.props.tasksInfo.deliveries.forEach((del) => {
      deliveries[del.id] = false;
    });
    this.setState({ deliveries });
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.tasksInfo.route.driver_id !==
      this.props.tasksInfo.route.driver_id
    ) {
      this.initializeDriver();
    }

    if (prevProps.tasksInfo.task !== this.props.tasksInfo.task) {
      this.filterRoutes();
    }
  }

  initializeDriver = () => {
    driverPosition = {};
    const { tasksInfo } = this.props;
    const { route, drivers } = tasksInfo;
    driver = drivers.find((driv) => driv.id === route.driver_id);
    channels = [driver.first_name];
    this.displayDriver();
  };

  calculateWithDirections = () => {
    this.state.places &&
      this.state.places.map((place, i) => {
        if (i !== 0 && !place.complete) {
          this.getDirections(
            i,
            this.state.places[i - 1].latitude,
            this.state.places[i - 1].longitude,
            place.latitude,
            place.longitude
          );
        }
      });
  };

  calculate = () => {
    const places = this.state.places || [];
    const bookingIds = Array.from(
      new Set(places.map((place) => place.booking_id))
    );

    // create separate batch for each booking_id
    const batches = bookingIds.map((bookingId) =>
      places.filter((place) => place.booking_id === bookingId)
    );
    // sort the batches by booking_id
    batches.sort(
      (batch1, batch2) => batch1[0].booking_id - batch2[0].booking_id
    );
    const newPlaces = batches.reduce((acc, batch) => [...acc, ...batch], []);

    // create new triangleCoords to match new order of places
    const newTriangleCoords = [];
    newPlaces.forEach((place) => {
      const position = new google.maps.LatLng(place.latitude, place.longitude);
      newTriangleCoords.push(position);
    });

    this.setState({
      places: newPlaces,
      triangleCoordsBasic: newTriangleCoords,
    });

    const interval = 5000; // set the interval to 200ms (adjust as needed)
    let batchIndex = 0;

    const getNextBatch = () => {
      const placesBatch = batches[batchIndex];
      const latLngBatch = placesBatch.map((place) => ({
        lat: Number(place.latitude),
        lng: Number(place.longitude),
      }));
      const origins = [...latLngBatch];
      if (batchIndex > 0) {
        const lastPlace = this.state.places[newOrder[newOrder.length - 1]];
        if (lastPlace) {
          origins.unshift({
            lat: Number(lastPlace.latitude),
            lng: Number(lastPlace.longitude),
          });
        }
      }
      this.getMatrix(origins, latLngBatch);

      batchIndex++;

      if (batchIndex < batches.length) {
        setTimeout(getNextBatch, interval); // call getNextBatch() again after interval
      } else {
        setTimeout(() => {
          this.reorder();
        }, interval);
      }
    };

    getNextBatch();
  };

  componentWillUnmount() {
    driverPosition = null;
    driver = null;
    channels = null;
  }
  hideCompleteAlert = () => {
    this.setState({ showComplete: false });
  };
  showCompleteAlert = () => {
    this.setState({ showComplete: true });
  };
  filterRoutes = () => {
    const { route, task, completedTasks } = this.props.tasksInfo;
    const orderedTasks = route.tasks
      .map((id) => task.find((x) => x.id == id))
      .map((x) => x);
    const places = orderedTasks.filter((del) => {
      return del.latitude && !del.complete;
    });
    const completedPlaces = completedTasks.filter((del) => {
      return del.latitude;
    });
    const bounds = new google.maps.LatLngBounds();
    const triangleCoordsBasic = [];
    [...places, ...completedPlaces].map((place) => {
      let position = new google.maps.LatLng(place.latitude, place.longitude);
      bounds.extend(position);
      triangleCoordsBasic.push(position);
    });

    this.setState({ places, completedPlaces, bounds, triangleCoordsBasic });
    this.plotPoints();
  };

  plotPoints = () => {
    let locations = this.getPoints(geocoder);
    console.log("locations", locations);

    Promise.all(locations).then((returnVals) => {
      returnVals.forEach((latLng) => {
        const delId = this.props.tasksInfo.task.find(
          (place) => place.id == latLng[2]
        );

        delId.latitude = latLng[0];
        delId.longitude = latLng[1];

        this.getCoords(delId.id, delId.latitude, delId.longitude);

        // this.setState({
        //   places: [...this.state.places, delId],
        // });
      });
    });
  };

  getCoords = (id, lat, long) => {
    const formData = new FormData();

    formData.append("task[id]", id);
    formData.append("task[latitude]", lat);
    formData.append("task[longitude]", long);
    formData.append("commit", "update");
    axios
      .patch(`${API_ROOT}/tasks/${id}`, formData, config)
      .then(({ data }) => this.props.getTasksInfo());
  };

  getAddressData = () => {
    const { route, task } = this.props.tasksInfo;
    let addressData = [];
    const filteredDeliveries = task.filter((del) => {
      return !del.latitude;
    });
    for (let i = 0; i < filteredDeliveries.length; i++) {
      let location = `${
        filteredDeliveries[i].address1.includes("-")
          ? filteredDeliveries[i].address1.split("-")[1]
          : filteredDeliveries[i].address1
      } + ${filteredDeliveries[i].city}`;
      addressData.push({
        id: filteredDeliveries[i].id,
        location: location,
      });
    }
    return addressData;
  };
  getPoints = (geocoder) => {
    let locationData = [];
    let addressData = this.getAddressData();
    for (let i = 0; i < addressData.length; i++) {
      // console.log("address", addressData);

      locationData.push(
        this.findLatLang(addressData[i].location, geocoder, addressData[i].id)
      );
    }
    return locationData; // array of promises
  };

  findLatLang = (address, geocoder, id) => {
    return new Promise(function (resolve, reject) {
      geocoder.geocode(
        {
          address: address,
        },
        function (results, status) {
          if (status === "OK") {
            // console.log(results);

            resolve([
              results[0].geometry.location.lat(),
              results[0].geometry.location.lng(),
              id,
            ]);
          } else {
            reject(new Error("Couldnt't find the location " + address));
          }
        }
      );
    });
  };

  displayStores = (stores) => {
    return stores.map((place, index) => {
      const position = {
        lat: place.shipfrom_latitude,
        lng: place.shipfrom_longitude,
      };
      const icon = "https://maps.google.com/mapfiles/kml/pal2/icon17.png";

      return (
        <Marker
          ref={(ref) => {
            this.refsArray[index] = ref;
          }}
          label={place.merchant_id.toString()}
          key={index}
          title={place.name}
          id={place.id}
          icon={icon}
          position={position}
        />
      );
    });
  };
  displayDriver = (driver) => {
    const image = "https://maps.google.com/mapfiles/kml/pal2/icon39.png";

    return <Marker label={driver} icon={image} position={driverPosition} />;
  };
  displayMarkers = (stores) => {
    return stores.map((place, index) => {
      const position = {
        lat: place.latitude || place.lat,
        lng: place.longitude || place.long,
      };
      const image = "https://maps.google.com/mapfiles/kml/pal3/icon49.png";
      const icon = place.complete ? image : null;

      return (
        <Marker
          ref={(ref) => {
            this.refsArray[index] = ref;
          }}
          label={(index + 1).toString()}
          key={index}
          id={place.id}
          title={place.name || place.shopify_order_id}
          merchant={place.name}
          icon={icon}
          position={position}
          onClick={this.onMarkerClick}
        />
      );
    });
  };

  onMapClick = ({ bounds }) => {
    if (this.state.directions) {
      const path = [];
      Object.values(this.state.directions).map((leg, index) => {
        if (index !== 0) {
          const polyline = google.maps.geometry.encoding.decodePath(
            leg.routes[0].overview_polyline
          );
          path.push(polyline);
        }
      });
      this.setState({
        triangleCoordsAll: path,
        triangleCoords: undefined,
        bounds: bounds,
      });
    } else {
      this.setState(() => ({
        triangleCoords: undefined,
        bounds: bounds,
      }));
    }
  };
  onMarkerClick = (props, marker) => {
    if (this.state.directions && marker.label !== 1) {
      const path = google.maps.geometry.encoding.decodePath(
        this.state.directions[marker.label - 1].routes[0].overview_polyline
      );
      this.setState({ triangleCoords: path, triangleCoordsAll: undefined });
    }
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ places, triangleCoordsBasic }) => ({
      places: arrayMove(places, oldIndex, newIndex),
      triangleCoordsBasic: arrayMove(triangleCoordsBasic, oldIndex, newIndex),
    }));
  };
  toggleMerchants = () => {
    this.setState({
      stores:
        this.state.stores.length > 0 ? [] : this.props.tasksInfo.merchants,
    });
  };

  handleDeliveries = (event) => {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState((prevState) => {
      return {
        deliveries: { ...prevState.deliveries, [name]: value },
      };
    });
  };

  handleCheckAll = (event) => {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState((prevState) => {
      return {
        merchants: { ...prevState.merchants, [name]: value },
      };
    });
    this.props.tasksInfo.deliveries.map((del) => {
      if (del.shipfrom_name == name) {
        this.setState((prevState) => {
          return {
            deliveries: {
              ...prevState.deliveries,
              [del.id]: value,
            },
          };
        });
      }
    });
  };

  uncheck = () => {
    this.setState((prevState) => ({
      deliveries: Object.keys(prevState.deliveries).reduce((acc, del) => {
        acc[del] = false;
        return acc;
      }, {}),
    }));
  };

  handleAddPickups = async (e) => {
    e.preventDefault();
    const token = `Bearer ${localStorage.getItem("token")}`;
    const headers = {
      Authorization: token,
      "Content-Type": "application/x-www-form-urlencoded",
    };

    const formData = new FormData();
    const deliveries = Object.keys(this.state.deliveries)
      .filter((del) => this.state.deliveries[del])
      .map((del) => del);

    formData.append("route[deliveries]", deliveries);

    try {
      const { data } = await axios.post(
        `${API_ROOT}/routes/addPickups?id=${this.props.tasksInfo.route.id}`,
        formData,
        { headers }
      );
      console.log(data);
      this.showCompleteAlert();
      this.setState({ pickups: false });
      this.uncheck();
      this.props.getTasksInfo();
    } catch (error) {
      console.error("Error in handleAddPickups:", error);
    }
  };

  handleConfirm = (e) => {
    e.preventDefault();

    const formData = new FormData();
    const tasksIds = [""];
    this.state.places.map((place) => {
      tasksIds.push(place.id);
    });
    tasksIds.push("");
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    formData.append("route[tasks]", tasksIds);
    formData.append("_method", "patch");

    axios
      .post(
        `${API_ROOT}/routes/updatetasks?id=${this.props.tasksInfo.route.id}`,
        formData,
        config
      )
      .then(({ data }) => console.log(data))
      .then(() => this.showCompleteAlert())
      .then(() => this.props.getTasksInfo())
      .catch((error) => console.log("api errors:", error));
  };

  reorder() {
    const tempPlaces = [];
    const tempCoords = [];
    this.state.newOrder.map((i) => tempPlaces.push(this.state.places[i]));
    this.state.newOrder.map((i) =>
      tempCoords.push(this.state.triangleCoordsBasic[i])
    );
    this.setState({ places: tempPlaces });
    this.setState({ triangleCoordsBasic: tempCoords });
    newOrder = [];
    this.showCompleteAlert();
  }

  getMatrix = (origins, destinations) => {
    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: origins,
        destinations: destinations,
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.METRIC,
        avoidHighways: false,
        avoidTolls: true,
      },
      (response, status) => {
        console.log({ response });
        if (status !== "OK") {
          alert("Error was: " + status);
        } else {
          const rows = response.rows;
          if (origins.length > destinations.length) rows.shift();
          let partOrder = [0];
          let minIndex = 0;
          for (let i = 0; i < rows.length - 1; i++) {
            let minValue = Infinity;
            rows[partOrder[partOrder.length - 1]].elements.map(
              (elem, index) => {
                if (
                  partOrder.includes(index) ||
                  rows[partOrder[partOrder.length - 1]].elements[index].duration
                    .value > minValue
                ) {
                } else {
                  minIndex = index;
                  minValue =
                    rows[partOrder[partOrder.length - 1]].elements[index]
                      .duration.value;
                }
              }
            );
            partOrder.push(minIndex);
          }
          if (newOrder.length > 0) {
            const part = partOrder.map((elem) => {
              return elem + newOrder.length;
            });
            partOrder = part;
          }
          const tmp = newOrder.concat(partOrder);
          newOrder = tmp;
          console.log({ newOrder });
          this.setState({ newOrder: newOrder });
        }
      }
    );
  };

  getDirections(i, startLat, startLong, destinationLat, destinationLong) {
    const directionsService = new google.maps.DirectionsService();
    const origin = new google.maps.LatLng(startLat, startLong);
    const destination = new google.maps.LatLng(destinationLat, destinationLong);
    const sendRequest = () => {
      directionsService.route(
        {
          origin,
          destination,
          travelMode: google.maps.TravelMode.DRIVING,
          avoidTolls: true,
          drivingOptions: {
            departureTime: new Date(),
            trafficModel: "bestguess",
          },
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            this.setState((prevState) => ({
              directions: {
                ...prevState.directions,
                [i]: result,
              },
            }));
          } else {
            console.error(
              `Error fetching directions for route ${i}: ${status}`
            );
          }
        }
      );
    };
    // If the route number is less than 10, send the request immediately.
    // Otherwise, stagger the requests by adding a delay,
    // to avoid overwhelming the API with too many requests at once.
    if (i < 10) {
      sendRequest();
    } else {
      setTimeout(sendRequest, (i - 9) * 1100);
    }
  }

  secondsToHms = (seconds) => {
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);
    return `${hours > 0 ? hours + "h " : ""}${
      minutes > 0 ? minutes + "m " : ""
    }`;
  };

  render() {
    const { route, drivers } = this.props.tasksInfo;
    const { places, completedPlaces, stores, pickups } = this.state;
    const driver = drivers.find((driv) => driv.id === route.driver_id);

    channels = driver ? [driver.first_name] : [];
    // console.log(channels);
    geocoder = new google.maps.Geocoder();
    const totalDistance = this.calculateTotalDistance();
    const totalTime = this.calculateTotalTime();
    return (
      <div>
        {!places ? (
          <Spinner />
        ) : (
          <div
            className="row"
            style={{
              height: "90vh",
              width: "100%",
            }}
          >
            <PubNubProvider client={pubnub}>
              <PubNubConsumer>
                {(client) => {
                  client.addListener({
                    message: (messageEvent) => {
                      driverPosition = {
                        lat: messageEvent.message[driver.first_name].latlng[0],
                        lng: messageEvent.message[driver.first_name].latlng[1],
                      };
                      // console.log(messageEvent.message[driver.first_name].data);
                    },
                  });
                  // console.log(driverPosition);
                  client.subscribe({ channels });
                }}
              </PubNubConsumer>
            </PubNubProvider>
            {this.state.showComplete && (
              <SweetAlert
                type="success"
                title="Route was successfully updated!"
                onConfirm={this.hideCompleteAlert}
                showCancel={false}
                confirmBtnText="OK"
                confirmBtnBsStyle="success"
                closeAnim={{
                  name: "hideSweetAlert",
                  duration: 100,
                }}
              />
            )}
            <div style={{ height: "600px" }} className="col-md-7">
              <h4 className="text-center">
                Route {route.id} - {places.length} remaining tasks -{" "}
                {this.secondsToHms(totalTime)} -{" "}
                {Math.round(totalDistance / 1000)} km
              </h4>

              <Map
                bounds={this.state.bounds}
                ref="map"
                google={window.google}
                onClick={this.onMapClick}
                style={mapStyles}
              >
                {this.displayMarkers(places)}
                {this.displayMarkers(completedPlaces)}
                {this.displayStores(stores)}
                {driver && this.displayDriver(driver.first_name)}
                {this.state.triangleCoordsAll &&
                  this.state.triangleCoordsAll.map((path, index) => {
                    // if (path.length > 1) {
                    return (
                      <Polyline
                        key={index}
                        path={path}
                        options={{
                          strokeColor: "#000",
                          strokeOpacity: 1,
                          strokeWeight: 2,
                        }}
                      />
                    );
                    // }
                  })}
                <Polyline
                  path={
                    this.state.triangleCoords
                      ? this.state.triangleCoords
                      : this.state.triangleCoordsAll
                      ? []
                      : this.state.triangleCoordsBasic
                  }
                  strokeColor="#0000FF"
                  strokeOpacity={0.8}
                  strokeWeight={2}
                />
              </Map>
            </div>
            <div
              className="col-md-5"
              style={{
                display: "block",
                height: "600px",
                width: "100%",
                overflow: "auto",
                position: "relative",
              }}
            >
              {places.length > 0 ? (
                <SortableContainer
                  onSortEnd={this.onSortEnd}
                  onSortStart={this.onSortStart}
                >
                  <Button variant="primary" onClick={this.calculate}>
                    Build Route
                  </Button>{" "}
                  <Button
                    variant="danger"
                    onClick={this.calculateWithDirections}
                  >
                    Calculate Remaining Route
                  </Button>{" "}
                  <Button variant="info" onClick={this.toggleMerchants}>
                    {stores.length > 0 ? "Hide Merchants" : "Show Merchants"}
                  </Button>{" "}
                  <Button
                    variant="warning"
                    onClick={() =>
                      this.setState({
                        pickups: !pickups,
                      })
                    }
                  >
                    {pickups ? "Show Tasks" : "Add Pickup Tasks"}
                  </Button>{" "}
                  {!this.state.pickups ? (
                    <Accordion>
                      {places.map((task, i) => {
                        let variant =
                          task.task_type === "pickup"
                            ? "outline-primary"
                            : "outline-secondary";

                        return (
                          !task.complete && (
                            <Card key={task.id}>
                              <Accordion.Toggle
                                as={Button}
                                variant={variant}
                                eventKey={`${task.id}`}
                              >
                                <SortableItem
                                  key={task.id}
                                  index={i}
                                  value={
                                    i != 0 &&
                                    this.state.directions &&
                                    this.state.directions[i]
                                      ? `${i + 1} - ${task.title} - ${
                                          this.state.directions[i].routes[0]
                                            .legs[0].duration_in_traffic.text
                                        } - ${
                                          this.state.directions[i].routes[0]
                                            .legs[0].distance.text
                                        } `
                                      : `${i + 1} - ${task.title}`
                                  }
                                />
                              </Accordion.Toggle>

                              <Accordion.Collapse eventKey={`${task.id}`}>
                                <Card.Body>
                                  <p>Name: {task.name}</p>
                                  {task.task_type !== "pickup" && (
                                    <p>Merchant: {task.merchant}</p>
                                  )}
                                  <p>
                                    Destination: {task.address1} {task.address2}
                                    , {task.city}, {task.province},{" "}
                                    {task.postal_code}
                                  </p>
                                  {task.delivery_instructions && (
                                    <p>
                                      Delivery Instructions:{" "}
                                      {task.delivery_instructions}
                                    </p>
                                  )}
                                  {task.pick_up_time && task.driver_id && (
                                    <p>
                                      Picked Up By: {driver.first_name} at{" "}
                                      {moment(task.pick_up_time).format(
                                        "MMMM Do YYYY, h:mm:ss a"
                                      )}
                                    </p>
                                  )}
                                  <p>Phone: {task.phone}</p>
                                  <a
                                    href={`sms:${task.phone}${
                                      navigator.userAgent.includes("Android")
                                        ? "?"
                                        : "&"
                                    }body=Hi ${
                                      task.name.split(" ")[0]
                                    }, my name is ${
                                      this.props.user.first_name
                                    } and I work for Mile1. I wanted to let you know that your driver ${
                                      driver && driver.first_name
                                    } has run into several issues on the road today and is now running quite far behind schedule. With that it looks like he might not make it to your place until about 4:00pm today. So sorry for the delay there. Would that still work for you?`}
                                  >
                                    <MessageIcon />
                                  </a>
                                </Card.Body>
                              </Accordion.Collapse>
                            </Card>
                          )
                        );
                      })}
                    </Accordion>
                  ) : (
                    <AddPickups
                      handleSubmit={this.handleSubmit}
                      handleCheckAll={this.handleCheckAll}
                      handleDeliveries={this.handleDeliveries}
                      handleAddPickups={this.handleAddPickups}
                      stateDeliveries={this.state.deliveries}
                      stateMerchants={this.state.merchants}
                      merchants={this.props.tasksInfo.merchants}
                      deliveries={this.props.tasksInfo.deliveries}
                      driver_id={this.props.tasksInfo.route.driver_id}
                    />
                  )}
                </SortableContainer>
              ) : (
                ""
              )}
              {!this.state.pickups && (
                <div className="container-fluid text-center">
                  <h4>Change Order and Press Confirm</h4>
                  <Button variant="primary" onClick={this.handleConfirm}>
                    Confirm
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
  calculateTotalDistance() {
    let totalDistance = 0;
    if (this.state.directions) {
      Object.keys(this.state.directions).forEach((i) => {
        totalDistance +=
          this.state.directions[i].routes[0].legs[0].distance.value;
      });
    }
    return totalDistance;
  }

  calculateTotalTime() {
    let totalTime = 0;
    if (this.state.directions) {
      Object.keys(this.state.directions).forEach((i) => {
        totalTime +=
          this.state.directions[i].routes[0].legs[0].duration_in_traffic.value;
      });
    }
    return totalTime;
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyCgImsLUsK-v_7T9gytx9fmfHyYL4HDnSQ",
})(withRouter(RouteTasksSortable));
